export default "__VITE_ASSET__Bx0JAlo7__"